export default "/credits/business/assets/2e955dd7f1ca6d15adb379e4ddc7c913.png";